import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: 'Come ricevo il libro?',
    a: "Riceverai subito un'email con il link di download dopo il pagamento."
  }, {
    q: 'Serve esperienza in cucina?',
    a: 'No, il libro è pensato per principianti. Ogni ricetta è spiegata passo dopo passo.'
  }, {
    q: 'Posso usarlo dal cellulare?',
    a: 'Sì, il libro è in formato PDF e puoi leggerlo da qualsiasi dispositivo.'
  }, {
    q: 'E se non mi piace?',
    a: 'Hai 45 giorni di garanzia. Se non sei soddisfatto, ti rimborsiamo al 100% senza domande.'
  }, {
    q: 'I bonus sono inclusi nel prezzo?',
    a: 'Sì, tutti e 4 i bonus sono inclusi GRATIS solo per oggi.'
  }, {
    q: 'Posso vendere i plumcake che preparo?',
    a: 'Assolutamente sì! Uno dei bonus è proprio una guida per iniziare a vendere.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-gray-50" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-65">
          ❓ Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-67">
                <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-68">
                  <span className="font-bold text-gray-900 pr-4" data-id="element-69">{faq.q}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-70" />
                </button>

                <AnimatePresence initial={false} data-id="element-71">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-72">
                      <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-4" data-id="element-73">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}